import React from "react"
import PokerCard from "./PokerCard"

const HalfCard = ({card, cardStyle, isFullLast = false, isShowType = false, isShowPickedSymbol = false, isShowMoneySymbol = false}) => {
  return (
    <div key={card.cardId} className="card-half" style={{ overflow: `${isFullLast ? 'unset !important' : ''}`, 
    width: `${isFullLast ? 'auto' : ''}` }}>
      <PokerCard card={card} wrapperClass={'card pokerCard'} wrapperStyle={cardStyle} isShowType={isShowType} isShowPickedSymbol={isShowPickedSymbol} isShowMoneySymbol={isShowMoneySymbol} />
    </div>
  )
}

export default HalfCard;